module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-module"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "module-goods"
  }, [_c('ul', {
    staticClass: "clearfix",
    attrs: {
      "id": "hmggDiv"
    }
  }, _vm._l((_vm.list), function(item) {
    return _c('li', {
      key: item.goodsId
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/goods',
          query: {
            goods_id: item.goodsId
          }
        },
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": item.designImage,
        "atl": item.name
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "tit"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "pri"
    }, [_vm._v("¥ " + _vm._s(item.price))])])], 1)
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "module-title dash"
  }, [_c('span', [_vm._v("还没逛够")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b2cdc40"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home-page/continue-shopping/index.vue
// module id = 1559
// module chunks = 1